import { useState } from 'react';

// Ορίζουμε ότι το T είναι το αποτέλεσμα της συνάρτησης (π.χ. User)
// και το A είναι ένας πίνακας με τα ορίσματα (arguments) της συνάρτησης
export function useMutation<T, A extends any[]>(
    mutationMethod: (...args: A) => Promise<T>
) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const execute = async (...args: A): Promise<T | undefined> => {
        setLoading(true);
        setError(null);
        try {
            const result = await mutationMethod(...args);
            return result;
        } catch (err: any) {
            setError(err.message || 'Σφάλμα κατά την αποθήκευση');
            throw err; 
        } finally {
            setLoading(false);
        }
    };

    return { execute, loading, error };
}